import { FEATURED_BOOK, SEARCH_KEYWORD } from "./actionTypes";

export const filterBookByFeatured = (value) => {
  return {
    type: FEATURED_BOOK,
    payload: value,
  };
};

export const searchBookByKeyword = (keyword) => {
  return {
    type: SEARCH_KEYWORD,
    payload: keyword,
  };
};
